import BaseAccordion from '@material-ui/core/ExpansionPanel'

const Accordion = BaseAccordion

export default Accordion
